import Model, { attr } from '@ember-data/model';

export default class GoodFaithEstimateOverviewModel extends Model {
  @attr('json') allSignatures;
}
